import { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { CommandPalette } from '../CommandPalette'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-3 lg:py-4 max-w-[1600px]">
        {children}
      </main>
      <Footer />
      <CommandPalette />
    </div>
  )
}
